import React, { Component, createRef } from "react";
import {
    SpaceBetween,
    Container, Alert
} from "@amzn/awsui-components-react";
import LinkServiceHeader from "../common/LinkServiceHeader";
import Constants from "../utils/Constants";
import LinkServiceBackendClient from "../common/LinkServiceBackendClient";
import HelperFunctions from "../common/HelperFunctions";
import TrailblazerVisualWrapper from "./TrailblazerVisualWrapper";
import TabSpinner from "../components/TabSpinner";
import LinkSearchFilter, { searchTermParseString } from "../search/LinkSearchFilter";
import FremontConstants from "../../../utils/Constants";
import SplitPanel from "../../../utils/SplitPanel";
import Chatbot from "../../../common/chatbot/Chatbot";

/**
 * This component handles the search term state and forwarding the search term
 * to the TrailblazerVisualizationContainer.
 */
export default class TrailblazerVisualizationPage extends Component {
    static SEARCH_STATES = {
        IDLE: "idle",
        SEARCHING: "searching",
        SUCCESS: "success",
        ERROR: "error"
    };

    constructor(props) {
        super(props);
        this.state = {
            searchState: TrailblazerVisualizationPage.SEARCH_STATES.IDLE,
            trailblazerOutput: null,
            errorMessage: ""
        };

        this.handleSearchTermSubmit = this.handleSearchTermSubmit.bind(this);
        this.searchTermRef = createRef();
    }

    componentDidMount = async () => {
        if (!this.searchTermRef.current) {
            return;
        }
        if (this.searchTermRef.current.state.searchTerm) await this.executeSearch();
    }

    linkServiceBackendClient = LinkServiceBackendClient.getInstance();

    async executeSearch() {
        this.setState({
            searchState: TrailblazerVisualizationPage.SEARCH_STATES.SEARCHING,
            errorMessage: ""
        });

        try {
            const trailblazerRouteOutput = await this.linkServiceBackendClient.trailblazerRoute(
                this.searchTermRef.current.state.searchTerm
            );

            this.setState({
                searchState: TrailblazerVisualizationPage.SEARCH_STATES.SUCCESS,
                trailblazerOutput: trailblazerRouteOutput
            });
        } catch (error) {
            HelperFunctions.displayFlashbarError(this, error);
            this.setState({
                searchState: TrailblazerVisualizationPage.SEARCH_STATES.ERROR,
                errorMessage: error.message,
                trailblazerOutput: null
            });
        }
    }

    async handleSearchTermSubmit() {
        const currentSearchTerm = window.location.href.split(FremontConstants.MANGO_ROUTES.trailblazerVisualization)[1]
            .slice(searchTermParseString.length);
        if (currentSearchTerm !== this.searchTermRef.current.state.searchTerm) {
            this.props.history.push(
                `${FremontConstants.MANGO_ROUTES.trailblazerVisualization}${searchTermParseString}${encodeURI(this.searchTermRef.current.state.searchTerm)}`
            );
        }

        await this.executeSearch();
    }

    renderContent() {
        const { searchState, trailblazerOutput, errorMessage } = this.state;

        switch (searchState) {
        case TrailblazerVisualizationPage.SEARCH_STATES.SEARCHING:
            return <TabSpinner/>;
        case TrailblazerVisualizationPage.SEARCH_STATES.ERROR:
            return <Alert>{errorMessage}</Alert>;
        case TrailblazerVisualizationPage.SEARCH_STATES.SUCCESS:
            return trailblazerOutput ?
                <TrailblazerVisualWrapper trailblazerOutput={trailblazerOutput}/> :
                <Container>
                    <div>LinkService client produced invalid Trailblazer API output</div>
                </Container>;
        default:
            return (
                <></>
            );
        }
    }

    render() {
        const {
            history, auth, sideNavError, user
        } = this.props;
        const { searchState } = this.state;

        return (
            <div key="trailblazer-visualization-page">
                <LinkServiceHeader
                    history={history}
                    auth={auth}
                    sideNavError={sideNavError}
                />
                <SplitPanel
                    user={user}
                    rightPanelContent={
                        <Chatbot
                            user={user}
                            auth={auth}
                            initialSuggestions={
                                this.searchTermRef.current && this.searchTermRef.current.state.searchTerm
                                    ? [Chatbot.createSearchSuggestion(`Provide a Trailblazer Summary for the search term: ${this.searchTermRef.current.state.searchTerm}.`)]
                                    : undefined
                            }
                        />
                    }
                >
                    <div>
                        <SpaceBetween size={Constants.PADDING_SIZES.SPACE_BETWEEN_SECTIONS}>
                            <LinkSearchFilter
                                ref={this.searchTermRef}
                                searchTermFromUrl={this.props.history.location.search}
                                primaryHeaderText="Enter Search Term to Visualize Route"
                                isSearchInProgress={searchState ===
                                    TrailblazerVisualizationPage.SEARCH_STATES.SEARCHING}
                                handleSearchTermSubmit={this.handleSearchTermSubmit}
                            />
                            {this.renderContent()}
                        </SpaceBetween>
                    </div>
                </SplitPanel>
            </div>
        );
    }
}
